import { useState } from "react";
import { useGetTicketsOrdersQuery } from "../../features/CallApi";
import { Container, Dropdown, Form, Table } from "react-bootstrap";
import { Gear } from "react-bootstrap-icons";
import { TicketsOrderStatus } from "./TicketsOrderStatus";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import LoadScreen from "../UI/LoadScreen";

export const Tickets = ({ }) => {
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [stringFilter, setStringFilter] = useState("");
    const [showAll, setShowAll] = useState(false);
    const { data, isLoading } = useGetTicketsOrdersQuery({ pageIndex, pageSize, stringFilter, showAll })


    return (
        <Container fluid>
            <h3>Заказы билетов</h3>
            <div className="d-flex mt-3">
                {/* <label htmlFor="stringFilter" className="form-label">E-Mail</label> */}
                <input type={`text`} id="stringFilter" onChange={
                    (e) => setTimeout(() => { setStringFilter(e.target.value) }, 1000)}
                    placeholder="Поиск.." name="stringFilter" className="form-control" />
            </div>
            <Form>
                <Form.Check // prettier-ignore
                    type="switch"
                    id="custom-switch"
                    label="Показать все"
                    defaultValue={showAll}
                    className="mt-1 mb-1"
                    onChange={() => setShowAll(!showAll)}
                />
            </Form>
            <Table responsive size="lg" style={{ fontSize: "14px" }}>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Статус</th>
                        <th>Код покупки</th>
                        <th>Шоу</th>
                        <th>Сумма заказа</th>
                        <th>Дата создания</th>
                        <th>E-Mail</th>
                        <th></th>
                    </tr>
                </thead>
                {!isLoading ?
                    <tbody>

                        <>{data?.getOrder?.length > 0 &&
                            <>
                                {data.getOrder.map(item =>
                                    <tr key={item.id}>
                                        <td>{item.id}</td>
                                        <td>
                                            <div><TicketsOrderStatus status={item.status} /></div>
                                            <div>{item.extResultCode && <>({item.extResultCode})</>}</div>
                                            {/* <div>{parse(new Date(item.createDateTime), "dddd")}</div> */}
                                            {/* {new Date(item.createDateTime)} */}
                                            {/* {item.createDateTime} */}
                                        </td>
                                        <td>
                                            <div>{item.reservationId}</div>
                                        </td>
                                        <td>
                                            <div>{item.nameInPremiera}</div>
                                            <div>{format(new Date(item.startOfEvent), 'HH:mm dd.MM.yyyy')}</div>
                                        </td>

                                        <td>{item.amount}</td>
                                        <td>{format(new Date(item.createDateTime), 'dd.MM.yyyy HH:mm:ss')}</td>
                                        <td>
                                            {/* <div> {item.client?.lastName} {item.client?.firstName} {item.client?.patronymic}</div> */}
                                            <div>{item.client?.email}</div>
                                        </td>
                                        <td style={{ width: 0 }}>
                                            <Dropdown className="mt-1">
                                                <Dropdown.Toggle variant="light" split={false}>
                                                    <Gear className='' size='14' />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Link role={"button"} className="dropdown-item" to={`/admin/ticketslc/details/${item.id}`}>Подробнее</Link>
                                                    {/* <Dropdown.Item>Подробнее</Dropdown.Item> */}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </td>
                                    </tr>
                                )}
                            </>
                        }</>
                    </tbody>
                    :
                    <>
                        <LoadScreen />
                    </>

                }
            </Table>

            <div className="d-flex flex-row justify-content-center align-content-center mt-3">
                <div className="btn-group">
                    <button
                        className={pageIndex === 1 ? `btn btn-primary disabled` : `btn btn-primary`}
                        onClick={() => {
                            if (pageIndex > 1) {
                                setPageIndex(pageIndex - 1)
                            }
                        }}>Назад</button>
                    <button
                        className={pageIndex === data?.totalPages || pageIndex === 0 ? `btn btn-primary disabled` : `btn btn-primary`}
                        onClick={
                            () => {
                                if (pageIndex <= data?.totalPages) {
                                    setPageIndex(pageIndex + 1)
                                }
                            }}
                    >Вперед</button>
                </div>
            </div>
        </Container>
    )
}